import React from "react";
import TutorModel from "../../api/models/TutorModel";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
type AvailableTutorsProps = {
  tutor: TutorModel;
  setSelected: (key: string | number) => void;
  selected: string | number;
};
function AvailableTutors(props: AvailableTutorsProps) {
  const { tutor, setSelected, selected } = props;
  return (
    <div className="w-full flex  border-b border-gray-100  py-3 px-3 md:px-6 gap-2 items-center ">
      <div className="flex h-4 items-center">
        <input
          id="tutor"
          aria-describedby="tutor-checkbox"
          name="tutor"
          type="checkbox"
          className="h-4 w-4  border-gray-300 rounded-full text-brandblue-400 focus:ring-brandblue-400"
          defaultChecked={selected === tutor?.id}
          checked={selected === tutor?.id}
          onChange={(e: any) => {
            if (e.target.checked) {
              setSelected(tutor?.id);
            } else {
              setSelected("");
            }
          }}
        />
      </div>
      <div className="flex gap-3 items-center">
        <UserProfilePictureAvatar
          alt={"tutor logo"}
          profilePictureUrl={tutor?.profile_picture_url}
          className="w-8 h-8 rounded-full "
        />
        {!!tutor.external_profile_url ? (
          <a
            className="text-blue-600 underline font-medium text-sm "
            href={tutor.external_profile_url}
            target="_blank"
          >
            {tutor?.firstName + " " + tutor?.lastName}
          </a>
        ) : (
          <h3 className="text-gray-600 font-medium text-sm ">
            {tutor?.firstName + " " + tutor?.lastName}
          </h3>
        )}
      </div>
    </div>
  );
}

export default AvailableTutors;
